export const breakTimeList = [
  {
    id: 0,
    name: "なし",
  },

  {
    id: 30,
    name: "30分",
  },

  {
    id: 60,
    name: "60分",
  },

  {
    id: 90,
    name: "90分",
  },
];
